import { FC } from "react";
import { Datagrid, List, ReferenceField, TextField } from "react-admin";

import CustomPagination from "../../components/CustomPagination";
import EmptyDataText from "../../components/EmptyDataText";
import TimestampField from "../../components/TimestampField";
import useCurrentUser from "../../hooks/useCurrentUser";
import useIsAdmin from "../../hooks/useIsAdmin";
import useUpdateListNotifications from "../../hooks/useUpdateListNotifications";
import { AppResource } from "../../types/resource.types";
import { agentDocRef, adminRef } from "../../utils/referencies";
import ListRowActions from "./components/ListRowActions";
import RequestsFilter from "./components/Filter";
import RequestsStatusText from "./components/RequestsStatusText";
import VisitRequestTime from "./components/VisitRequestTime";

const VisitsRequestsList: FC<any> = (props) => {
  const { user } = useCurrentUser();
  const { isAdmin } = useIsAdmin();

  useUpdateListNotifications(
    isAdmin ? adminRef(user.id as string) : agentDocRef(user.id as string),
    AppResource.visitsRequests,
    AppResource.requestsLastSeenAt
  );

  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      filters={<RequestsFilter userId={user.id} />}
      exporter={false}
    >
      <Datagrid empty={<EmptyDataText message="No visits requests yet!" />}>
        <TextField source="identifier" label="Request ID" sortable={false} />
        <ReferenceField
          label="Client"
          source="clientId"
          reference={`${AppResource.clients}`}
          sortable={false}
          link={false}
        >
          <TextField source="displayName" />
        </ReferenceField>
        <VisitRequestTime source="visitingDate" label="Visiting date" sortable={false} />
        <TimestampField source="createdAt" label="Created At" />
        <RequestsStatusText source="status" label="Status" sortable={false} />
        <ListRowActions />
      </Datagrid>
    </List>
  );
};

export default VisitsRequestsList;
